import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch, useStore as useReduxStore } from 'react-redux';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import { hotjar } from 'react-hotjar';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Avatar,SvgIcon, CircularProgress, Typography, Fab, Card, Snackbar, LinearProgress, Box, Drawer, TextField, Button, Modal, Container, Paper, Grid, IconButton, InputAdornment, Tooltip, Select, MenuItem, FormControl, InputLabel, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import ScheduleRoundedIcon from '@material-ui/icons/ScheduleRounded';
import { Visibility, VisibilityOff, CheckCircleRounded, SentimentVerySatisfied, SettingsVoiceRounded } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import MobileStepper from '@material-ui/core/MobileStepper';
import config from './config/environment';
import { getDashboardUser, getDashboardTenant } from './utils/dashboardAuthParams';

// React Flow Renderer and Dagre for layout
import ReactFlow, {
    ReactFlowProvider,
    useStore,
    removeElements,
    addEdge,
    Background,
    Controls,
    MiniMap,
    isNode,
    applyNodeChanges,
    applyEdgeChanges,
    useZoomPanHelper 
} from 'react-flow-renderer'; // Ensured correct imports for React Flow Renderer
import dagre from 'dagre';
import { v4 as uuid } from 'uuid'; // Kept uuid import for node ID generation

// Custom Components and Nodes
import { AppBarHeader } from './components/AppBar';
import { AppBarHeaderDummy } from './components/AppBarDummy';
import ActionPanel from './components/NodePanels/ActionPanel';
import ReadOnlyActionPanel from './components/NodePanels/ReadOnlyActionPanel';
import TriggerPanel from './components/NodePanels/TriggerPanel';
import ReadOnlyTriggerPanel from './components/NodePanels/ReadOnlyTriggerPanel';
import FilterPanel from './components/EdgePanels/FilterPanel';
import ActionNode from './components/CustomNodes/ActionNode';
import TriggerNode from './components/CustomNodes/TriggerNode';
import SkeletonNode from './components/CustomNodes/SkeletonNode';
import FilterEdge from './components/CustomEdges/FilterEdge';
import ConnectionLine from './components/ConnectionLine';
import { allStepsReady } from './components/helpers/stepReady';

// Redux Slice Actions
import {
    nodeAdded,
    edgeAdded,
    elementUpdated,
    selectNotification,
    notification,
    fetchWorkflow,
    nodeEdgeAdded,
    saveWorkflow,
    activeUpdated,
    elementSelected,
    selectWorkflowElements,
    selectElementById,
    selectWorkflowName,
    selectParentTree,
    selectWorkflowTemplateNodes,
    selectWorkflowActive,
    selectCurrentElement,
    selectTenantSelection,
    selectWorkflowLoading,
    createWorkflow,
    createTemplate0,
    createTemplate5,
    createTemplate1,
    createTemplate2,
    createTemplate4,
    acceptTemplateNew,
    acceptTemplateExist,
    completeTemplateAccept
} from './features/workflow/workflowSlice';

import { selectWorkflowID } from './features/execution/executionSlice';

const modalheight = window.innerHeight;
const modalwidth = window.innerWidth;

function getModalStyle() {
    const top = 5
    //const left = 50 + rand();

    return {
        top: '${top}%',
        margin: 'auto'
      //  left: ${left}%,
      //  transform: translate(-${top}%, -${left}%),
    };
}

let breakpointZoom = ''

if (modalwidth < 450) {
    breakpointZoom = 0
} else if (modalwidth < 720 && modalwidth > 449) {
    breakpointZoom = 1
} else if (modalwidth > 721) {
    breakpointZoom = 1
}



let breakpointPosition = ''

if (modalwidth < 450) {

    var breakpointPositionWidth = modalwidth / 2 - 225
    breakpointPosition = [breakpointPositionWidth, 20]

} else if (modalwidth < 720 && modalwidth > 390) {

    var breakpointPositionWidth = modalwidth / 2 - 425
    breakpointPosition = [breakpointPositionWidth, 20]

} else if (modalwidth > 721) {

    var breakpointPositionWidth = modalwidth / 2 - 625
    breakpointPosition = [breakpointPositionWidth, 20]

}



const useStyles = makeStyles((theme) => ({
    fab: {
        '& > *': {
            margin: theme.spacing(1),

        },
        position: 'fixed',
        bottom: theme.spacing(2),
        left: theme.spacing(2),
        zIndex: 9
    },
    modal: {
        position: 'absolute',
        width: '350px',
        //height: modalheight * .85,
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        overflowY: 'scroll'
    },

    modalSmall: {
        position: 'absolute',
        width: '66%',
       
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        overflowY: 'scroll'
    },
    modaltour: {
        position: 'absolute',
        width: '50%',
        height: modalheight * .75,
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        overflowY: 'scroll'
    },
    modalverify: {
        position: 'absolute',
        width: '50%',
        height: '40%',
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        overflowY: 'scroll'
    },
    drawerAnimate: {

        animationName: '$fade',
    },
    '@keyframes fade': {
        '0%': { opacity: '0' },
        '100%': { opacity: '1' },
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        maxWidth: 5000,
        backgroundColor: '#f5f5f5',
        
      },
      paper: {
        padding: theme.spacing(4),
        maxWidth: 1000,
        width: '100%',
        marginTop: '50px'
      },
      form: {
        marginTop: theme.spacing(2),
      },
      button: {
       // backgroundColor: '#0069ea',
        color: 'white',
        textTransform: 'none',
        marginTop: theme.spacing(2),
        borderRadius: 8
       // '&:hover': {
        //  backgroundColor: '#0075ea',
       // },
      },
      googleButton: {
        width: '100%',
        marginBottom: theme.spacing(2),
        backgroundColor: 'rgb(66, 133, 244)'
      },
      leftContent: {
        paddingRight: theme.spacing(4),
        borderRight: '1px solid ${theme.palette.divider}',
      },
      rightContent: {
        paddingLeft: theme.spacing(4),
      },
      iconContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing(2),
      },
      icon: {
        marginRight: theme.spacing(2),
        height: 40,
        width: 40,
      },
      benefits: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
      },
      checkIcon: {
        color: 'green',
        marginRight: theme.spacing(1),
      },
      trustedSection: {
        marginTop: theme.spacing(4),
        textAlign: 'center',
      },
      companyLogos: {
        marginTop: theme.spacing(2),
      },
      logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center', // Added to center logos
        marginBottom: theme.spacing(2),
      },
      logo: {
        maxWidth: 150,
        height: 'auto',
        margin: theme.spacing(2),
      },
      progressBar: {
        height: 10,
        '& .MuiLinearProgress-bar': {
          backgroundColor: (props) => props.color, // Dynamic color
        },
      },
}));


const nodeTypes = {
    action: ActionNode,
    trigger: TriggerNode,
    skeleton: SkeletonNode,
};

const edgeTypes = {
    filter: FilterEdge
}

export default ({ workflowID = null }) => {
    // const [workflow, setWorkflow] = useState(null)
    // const [elements, setElements] = useState([{ id: uuid(), type: 'trigger', position: { x: 200, y: 200 }, data: { name: 'Add trigger' } }])
    const theme = useTheme();
    const selectedElementID = useSelector(selectCurrentElement)
    const selectedElement = useSelector(selectElementById(selectedElementID))
    // const [parentTree, setParentTree] = useState({})

    const [openalert, setOpenAlert] = React.useState(false);
    const [source, setSource] = useState(null);
    const sourceRef = useRef();
    const [target, setTarget] = useState(null);
    const targetRef = useRef();
    const dispatch = useDispatch();
    const reduxStore = useReduxStore();
    const name = useSelector(selectWorkflowName)
    const elements = useSelector(selectWorkflowElements)
    const workflow = useSelector(selectWorkflowTemplateNodes)
    const active = useSelector(selectWorkflowActive)
    
    const [modalStyle] = React.useState(getModalStyle);
    const notify = useSelector(selectNotification)
    const tenantSelection = useSelector(selectTenantSelection)
    const workflowLoading = useSelector(selectWorkflowLoading)
    const activationRequestRef = useRef(null);
    const reactFlowInstanceRef = useRef(null);

    const [selectedTenant, setSelectedTenant] = useState('')
    const [tenantModalOpen, setTenantModalOpen] = useState(false)
   
  
   
  /* useEffect(() => {
   var tourReady = localStorage.getItem('tourReady')
   var template = localStorage.getItem('template')
   var visitCount = localStorage.getItem('visitCount')

   if (modalwidth > 1136 && visitCount < '4' && template === '5' && tourReady !== 'false') {
    //toggle this to turn the tour on or off
    setModalOpenTour(false)
   } else if (tourReady === 'false') {
       setModalOpenTour(false)
   }
  }, []) */


   const [openstep, setOpenStep] = useState(true)
   
   // Handle tenant selection modal
   useEffect(() => {
       if (tenantSelection && tenantSelection.tenants && tenantSelection.tenants.length > 0) {
           // Set flag to disable beforeunload warning during tenant selection
           localStorage.setItem('templateAcceptanceInProgress', 'true');
           setTenantModalOpen(true)
           // Set first tenant as default selection
           if (!selectedTenant && tenantSelection.tenants.length > 0) {
               setSelectedTenant(tenantSelection.tenants[0].id)
           }
       } else {
           // Clear flag when tenant selection is not active
           localStorage.removeItem('templateAcceptanceInProgress');
           setTenantModalOpen(false)
       }
   }, [tenantSelection, selectedTenant])
   
   const handleTenantSelect = () => {
       if (selectedTenant && tenantSelection) {
           // Use workflowName if available (from helper function), otherwise use userName
           const workflowName = tenantSelection.workflowName || tenantSelection.userName;
           dispatch(completeTemplateAccept({
               selectedTenant: selectedTenant,
               djangoId: tenantSelection.djangoId,
               scaffoldId: tenantSelection.scaffoldId, // Pass scaffoldId if available
               userName: workflowName,
               token: tenantSelection.token,
               currentUser: tenantSelection.currentUser
           }))
           setTenantModalOpen(false)
       }
   }
   
   const handleTenantModalClose = () => {
       // Clear flag before redirecting
       localStorage.removeItem('templateAcceptanceInProgress');
       setTenantModalOpen(false)
       // Redirect back to automate.workload.co if user cancels
       window.location.replace('https://automate.workload.co')
   }
   
    useEffect(() => {
    if (openstep === true && elements.length > 0 && workflow) {
 
        const workflowobj = Object.entries(workflow)
      const filtered = workflowobj.filter(step => {
        const stepobj = step[1].outputFields
        const isEmpty = Object.keys(stepobj).length === 0;
        
        return isEmpty === true;
      });
      // 👇️ [{id: 1, name: 'Alice', country: 'Canada'},
     
      if (filtered.length === 0){
        setOpenStep(false)
      } else {
        const x = filtered[0]
        const f = x[1].id
    //setSelectedElement(elements.find(item => item.id == f))
        dispatch(elementSelected(f))
        setOpenStep(false)
       
      }
    }

}, [openstep])  
 
  const [width, setWindowWidth] = useState(0)
  const [breakpoint, setBreakPoint] = useState('')
 
      
 
   useEffect(() => { 

     updateDimensions();

     window.addEventListener('resize', updateDimensions);
     return () => 
       window.removeEventListener('resize',updateDimensions);
    }, [])

    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
    }
  
    useEffect(() => {
        if (width > 721) {
          setBreakPoint('large')
          }
          else if (width < 720 && width > 431) {
           
              setBreakPoint('medium')
          }
          else if (width < 431) {
              setBreakPoint('small')
          }
    }, [width])
    


    const handleDesktopModalClose = () => {
        setDesktopReminderModal(false);
    };


    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    let query = useQuery();
    let id = query.get("id")
    if (id === null) {
        id = uuid();
     
    }
    // If u/t are missing from the URL, read localStorage (applyDashboardAuthFromUrl always persists them).
    const [user, setUser] = useState(() => query.get("u") || getDashboardUser() || null);
    const [tenant, setTenant] = useState(() => query.get("t") || getDashboardTenant() || null);
    const template = query.get("template")
    const template_id = query.get("template_id")
    const app1 = query.get("app1")
    const action1 = query.get("action1")
    const app2 = query.get("app2")
    const action2 = query.get("action2")
    const cook = localStorage.getItem('tok_')
    if (user) {
      localStorage.setItem('user', user)
    }
    if (tenant) {
      localStorage.setItem('tenant', tenant)
    }

    // Redirect to signup if accessing templates without token
    useEffect(() => {
      const token = localStorage.getItem('tok_');
      const hasTemplate = template || template_id;
      
      // If accessing a template without token, redirect to signup
      if (hasTemplate && !token) {
        const currentUrl = window.location.href;
        window.location.href = `https://automate.workload.co/auth/signup?next=${encodeURIComponent(currentUrl)}`;
        return;
      }
      
      // Treat as signed in if JWT exists (dashboard deep-link strips u/t from URL after persisting).
      const userResolved = user || getDashboardUser() || null;
      if (!userResolved && !token && !template_id && !template && workflowID) {
        const currentUrl = window.location.href;
        window.location.href = `https://automate.workload.co/auth/signup?next=${encodeURIComponent(currentUrl)}`;
      }
    }, [user, template_id, template, workflowID])
    

    const handleClickAlert = () => {
        setOpenAlert(true);
    };
    useEffect(() => {
        if (notify && notify.status) {
            handleClickAlert();
        }
    }, [notify])

    useEffect(() => {
        sourceRef.current = source
    }, [source])

    useEffect(() => {
        
        targetRef.current = target
    }, [target])

    

    useEffect(() => {
        if (modalwidth > 719){
            
        const script = document.createElement('script');

        script.src = "https://js.hs-scripts.com/6870309.js";
        script.async = true;
        script.id = "hs-script-loader";

        document.body.appendChild(script);
        window.hsConversationsSettings = {
            identificationEmail: localStorage.getItem('email'),
            
         };

        return () => {
            document.body.removeChild(script);
        }
        
    }}, []);
    const [accessDenied, setAccessDenied] = useState(false)
    const [workflowloading, setWorkflowLoading] = useState(false)
    useEffect(() => {
      //get the workflow from the server
      
      if (workflowID) {
          // If user has a token, verify they have access to this workflow
          if (cook) {
              setWorkflowLoading(true);
              checkWorkflowAccess(workflowID, cook)
                  .then((result) => {
                      if (result.hasAccess) {
                          // User has access, fetch the workflow
                          setAccessDenied(false);
                          dispatch(fetchWorkflow(workflowID))
                              .then((actionResult) => {
                                  // Check if the action was fulfilled or rejected
                                  if (actionResult.type === 'workflow/fetchWorkflow/fulfilled') {
                                      // Workflow loaded successfully
                                      setWorkflowLoading(false);
                                      // Identify user when workflow loads
                                      if (cook) {
                                          const { identifyUser } = require('./utils/posthog');
                                          identifyUser(cook);
                                      }
                                  } else if (actionResult.type === 'workflow/fetchWorkflow/rejected') {
                                      // Workflow fetch failed - check if it's an access issue
                                      const errorStatus = actionResult.payload?.status;
                                      if (errorStatus === 403 || errorStatus === 404) {
                                          setAccessDenied(true);
                                      }
                                      setWorkflowLoading(false);
                                  }
                              })
                              .catch((error) => {
                                  // Network or other error
                                  setAccessDenied(true);
                                  setWorkflowLoading(false);
                              });
                      } else {
                          // User doesn't have access
                          setAccessDenied(true);
                          setWorkflowLoading(false);
                      }
                  })
                  .catch((error) => {
                      // Error checking access - deny by default for security
                      setAccessDenied(true);
                      setWorkflowLoading(false);
                  });
          } else {
              // No token - access denied (user will be redirected to signup)
              setAccessDenied(true);
              setWorkflowLoading(false);
          }
      }
     /*  else if (user && tenant && id) {
          setWorkflowLoading(false)
          dispatch(fetchWorkflow(workflowID))
          if (!cook) {
              setWorkflowLoading(false)
               setAccessDenied(true)
          }
         
         

      } */
      else if (template_id && cook) {
          mixpanel.track('Share Accepted', {
              'url': 'https://editor.workload.co/?template_id='+template_id,
              'user': user
          });
          // Set flag early to prevent beforeunload warning during template acceptance
          localStorage.setItem('templateAcceptanceInProgress', 'true');
          setWorkflowLoading(true)
          dispatch(acceptTemplateExist({ template_id: template_id, token: cook }))
      }
      else if (template_id && !cook) {
          mixpanel.track('Share Accepted', {
              'url': 'https://editor.workload.co/?template_id='+template_id,
              'user': user
          });
          // Set flag early to prevent beforeunload warning during template acceptance
          localStorage.setItem('templateAcceptanceInProgress', 'true');
          setWorkflowLoading(true)
          dispatch(acceptTemplateNew({ template_id: template_id, scaffoldId: id}))
         
         
      }
      else if (template == 0) {
          // Set flag early to prevent beforeunload warning during template acceptance
          localStorage.setItem('templateAcceptanceInProgress', 'true');
          setWorkflowLoading(true)
          dispatch(createTemplate0({ id: id, app: app1,cook: cook ? true : false, token: cook ? cook : null }))
          
         
      } else if (template == 1) {
          // Set flag early to prevent beforeunload warning during template acceptance
          localStorage.setItem('templateAcceptanceInProgress', 'true');
          setWorkflowLoading(true)
          dispatch(createTemplate1({ id: id, app: app1, action: action1, cook: cook ? true : false, token: cook ? cook : null }))
          
         
      }
      else if (template == 2) {
          // Set flag early to prevent beforeunload warning during template acceptance
          localStorage.setItem('templateAcceptanceInProgress', 'true');
          setWorkflowLoading(true)
          dispatch(createTemplate2({ id: id, app1: app1, app2: app2, cook: cook ? true : false, token: cook ? cook : null }))
        
          
      }
      else if (template == 4) {
          // Set flag early to prevent beforeunload warning during template acceptance
          localStorage.setItem('templateAcceptanceInProgress', 'true');
          setWorkflowLoading(true)
          dispatch(createTemplate4({ id: id, app1: app1, action1: action1, app2: app2, action2: action2, cook: cook ? true : false, token: cook ? cook : null }))
             
           
         }
      else if (template == 5) {
          localStorage.setItem('template',5)
          // Set flag early to prevent beforeunload warning during template acceptance
          localStorage.setItem('templateAcceptanceInProgress', 'true');
          setWorkflowLoading(true)
          dispatch(createTemplate5({ id: id, cook: cook ? true : false, token: cook ? cook : null}))
        
      }
      else {
          
              localStorage.setItem('template',5)
              setWorkflowLoading(false)
              mixpanel.identify(user) 
              dispatch(createWorkflow(id))
             
          
         
      }
  }, [])

    // When a template thunk fulfills, Redux workflow gets elements; clear local loading.
    useEffect(() => {
      if (workflowloading && workflow && Array.isArray(workflow) && workflow.length > 0) {
        setWorkflowLoading(false);
      }
    }, [workflow, workflowloading]);

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const updateNode = node => {
        dispatch(elementUpdated(node.id, null, node.position))
    }
   
    const handleElementClick = (event, el) => {
        if (el.type === 'skeleton') return;

        if (event.target.outerHTML.startsWith("<div data-handleid")) {
          return
        }

        if (event.target.outerHTML.startsWith('<span class="MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock">Delete Step')){
          if (reactFlowInstance) {
            reactFlowInstance.fitView({ padding: 0.1 }); // Layout nodes on initial load
           }
           return
        }
        if (event.target.outerHTML.startsWith('<span class="MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock">Duplicate')){
          if (reactFlowInstance) {
            reactFlowInstance.fitView({ padding: 0.1 }); // Layout nodes on initial load
           }
           return
        }

        if (el.type === 'trigger') {
          handlePaneClick()
          dispatch(elementSelected(el.id))
        } else {
         // handlePaneClick()
        dispatch(elementSelected(el.id))
        }

       // hotjar.event('node-click');
        mixpanel.track('Node Selected', {
            'app': el.app,
            'user': user
        });
    
    }
  


    const handlePaneClick = (event) => {
    //reactFlowInstance.fitView({padding: .2})
        dispatch(saveWorkflow(1))
        // setSelectedElement(null);
        dispatch(elementSelected(null))
        // dispatch(deletefilterclick(filterC))
        if (reactFlowInstance) {
          reactFlowInstance.fitView({ padding: 0.1 }); // Layout nodes on initial load
         }

    }

    const handleNodeMove = (event, node) => {
        updateNode(node)
        handleSaveClick();
    }

    const handleonConnectStart = (event, { nodeId, handleType }) => {
        if (!allStepsReady(elements)) return;
        setTarget(null)
        setSource(nodeId);
        handleSaveClick();
    }
const [reactFlowInstance, setReactFlowInstance] = useState()
    reactFlowInstanceRef.current = reactFlowInstance
    const initialFitViewDone = useRef(false)




     
    
    
    // const {project} = useZoomPanHelper();
    //const firstelement = reactFlowInstance?.getElements({})
    //const fstelmnt = Object.assign({}, firstelement)
    //const f = fstelmnt[0]
    
  
    
    /* const handleLineDrop_old = (event) => {

        // const rfBounds = rfWrapper.current.getBoundingClientRect();
        const position = reactFlowInstance.project({
            x: event.clientX - 225,
            y: event.clientY + 30
        })
        // var x = event.layerX - 10;
        // var y = event.layerY - 55;
        var x = position.x;
        var y = position.y;
        // addNode(x, y);
        
        if (event.toElement.dataset.nodeid !== sourceRef.current && event.toElement.dataset.nodeid !== undefined ) {
            
            dispatch(edgeAdded('filter', sourceRef.current, event.toElement.dataset.nodeid ))
            setTarget(null)
            handleSaveClick();
        }
        else {
           
           if (workflow[sourceRef.current] && workflow[sourceRef.current].type === 'polling') {
            dispatch(nodeEdgeAdded('action', x+450, y, 'filter', sourceRef.current))
            setSource(null)
            dispatch(notification({"status": "info", "message": "Action step added"}))
            handleSaveClick();
         
            setFirstLoad(true)
           } else if (workflow[sourceRef.current] && workflow[sourceRef.current].type === 'webhook') {
            dispatch(nodeEdgeAdded('action', x+450, y, 'filter', sourceRef.current))
            setSource(null)
            dispatch(notification({"status": "info", "message": "Action step added"}))
            handleSaveClick();
           
            setFirstLoad(true)
           } else if (workflow[sourceRef.current] && Object.keys(workflow[sourceRef.current]['connections']).length !== 0) {
            dispatch(nodeEdgeAdded('action', x+450, y, 'filter', sourceRef.current))
            handlePaneClick();
            setSource(sourceRef.current)
            dispatch(notification({"status": "info", "message": "Action step added"}))
            handleSaveClick();
            handleOpenElement(workflow[sourceRef.current])
            setFirstLoad(true)
           } else if (workflow[sourceRef.current] && Object.keys(workflow[sourceRef.current]['connections']).length === 0) {
            dispatch(nodeEdgeAdded('action', x, y, 'filter', sourceRef.current))
            setSource(null)
            handleSaveClick();
            
            dispatch(notification({"status": "info", "message": "Action step added"}))
            setFirstLoad(true)
          
           }
           else {
            
            dispatch(nodeEdgeAdded('action', x, y, 'filter', sourceRef.current))
            setSource(null)
            handleSaveClick();
            dispatch(notification({"status": "info", "message": "Action step added"}))
            setFirstLoad(true)
          
           }
        }

    }
 */
    const handleLineDrop = (event) => {
      if (!allStepsReady(elements)) return;
      const position = reactFlowInstance.project({
        x: event.clientX - 225,
        y: event.clientY + 30
      });
    
      const x = position.x;
      const y = position.y;
    
      if (event.toElement.dataset.nodeid !== sourceRef.current && event.toElement.dataset.nodeid !== undefined) {
        dispatch(edgeAdded('filter', sourceRef.current, event.toElement.dataset.nodeid));
        setTarget(null);
        handleSaveClick();
      } else {
        let newNodeId = uuid(); // Create a unique ID for the new node
        // Handle case when adding an action node from the trigger
        if (workflow[sourceRef.current] && workflow[sourceRef.current].type === 'polling') {
          dispatch(nodeEdgeAdded('action', x, y, 'filter', sourceRef.current, newNodeId));
        } else if (workflow[sourceRef.current] && workflow[sourceRef.current].type === 'webhook') {
          dispatch(nodeEdgeAdded('action', x + 450, y, 'filter', sourceRef.current, newNodeId));
        } else {
          dispatch(nodeEdgeAdded('action', x, y, 'filter', sourceRef.current, newNodeId));
        }
        handlePaneClick()

        handleSaveClick();
        // Select the newly added node and update the side panel
        dispatch(elementSelected(newNodeId));
        setFirstLoad(true);
        
      }
   
    };
    


    const handleSaveClick = () => {
       // dispatch(notification({"status": "success", "message": "Your changes were auto-saved..."}))
        dispatch(saveWorkflow(1))
       // hotjar.event('save-click');

    }

    // Use theme to get dynamic background color for dark mode
    const flowStyle = { 
        background: theme.palette.type === 'dark' 
            ? theme.palette.background.default 
            : '#f2f2f2', 
        height: '100vh', 
        width: '100vw', 
        zIndex: 0,  
        cursor: 'grab' 
    }

    const onElementsRemove = (elementsToRemove) => {

        // setElements(elements => removeElements([elementsToRemove], elements))
         handlePaneClick();
layoutNodes()
        if (reactFlowInstance) {
          reactFlowInstance.fitView({ padding: 0.1 }); // Layout nodes on initial load
         }
       // hotjar.event('remove-click');
    }



    const onConnect = (params) => {
        setTarget(params.target)
     //   dispatch(edgeAdded('filter', params.source, params.target))
        // setElements(els => addEdge({ ...params, animated: true, type: 'filter', style: { stroke: 'gray', strokeWidth: 2 }, data: { text: 'empty', fields: baseFields } }, els))
    }

    const handleKeyDownSave = event => {

        let charCode = String.fromCharCode(event.which).toLowerCase();
        if ((event.ctrlKey || event.metaKey) && charCode === 's') {
            event.preventDefault();
            handleSaveClick();
            dispatch(notification({ "status": "success", "message": name + " was auto-saved" }))
        } else {
            return;
        }
    }

    const [firstload, setFirstLoad] = useState(false)

   

    useEffect(() => {
      if (firstload === true && elements.length > 0 && workflow) {
        const workflowobj = Object.entries(workflow);
        const lastElement = workflowobj.slice(-1);
        const newNodeId = lastElement[0][1]?.id;
    
        if (newNodeId) {
          dispatch(elementSelected(newNodeId));
          setOpenStep(true)
        }
        setFirstLoad(false);
      }
    }, [firstload]);
    
const [triggerData, setTriggerData] = useState(null)
const [actionData, setActionData] = useState(null)
     useEffect(() => {
        if (triggerData == null) {
    setTriggerData(elements.filter(element => element.type !== 'filter')[0])
    setActionData(elements.filter(element => element.type !== 'filter')[1])
        }
    }, [elements])
 


    const [desktopreminderloading, setDesktopReminderLoading] = useState(false)
    const [desktopReminderModal, setDesktopReminderModal] = useState(false)
    const [deskworkemail, setDeskWorkemail] = useState();
    const [validworkemail, setValidworkemail] = useState(true)
    const handleDeskWorkemailChange = (e) => {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if(e.match(mailformat))
            {
              //.log('matches email address format')
            setValidworkemail(true);
            //handleDesktopReminder();

            }
            else
            {
            setValidworkemail(false)
            }
        }

    const handleDesktopReminder = () => {
        setDesktopReminderLoading(true)
        let data =  {
            email: deskworkemail,
         }

        let config = {
        method: 'post',
        url: 'https://editor.workload.co:5000/addnewcontact',
        headers: {  
            'Content-Type': 'application/json'
        },
        data : data
        };

        axios(config)
        .then((response) => {
        const data2 = JSON.stringify(
            {
                email: deskworkemail,
                href: window.location.href
             }
        )
        let config_send = {
            method: 'post',
            url: 'https://editor.workload.co:5000/sendreminder',
            headers: { 
                
                'Content-Type': 'application/json'
            },
            data : data2
            };
    
            axios(config_send)
            .then((response) => {
        setDesktopReminderLoading(false)
        setDesktopReminderModal(false)
    })
})
    .catch((error) => {
    });

    }

    // Initialize Material-UI classes
    const classes = useStyles();

    // Security check function to verify user has access to workflow
    const checkWorkflowAccess = async (workflowId, token) => {
        try {
            // First verify the token is valid and get user info
            const meResponse = await axios({
                method: 'get',
                url: 'https://backend.workload.co/api/auth/me',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            });

            if (!meResponse.data || !meResponse.data.id) {
                return { hasAccess: false, error: 'Invalid token' };
            }

            // Try to fetch the workflow - if it fails with 403/404, user doesn't have access
            // The fetchWorkflow will be called separately, but we can check access here
            // by attempting to verify the workflow exists and user has permission
            try {
                const workflowCheck = await axios({
                    method: 'post',
                    url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        operation: 'getWorkflow',
                        id: workflowId
                    }
                });

                // If we get here, workflow exists
                // We should also check if user has access via backend API
                // For now, if workflow exists and token is valid, allow access
                // The backend should handle permission checks
                return { hasAccess: true, userId: meResponse.data.id };
            } catch (workflowError) {
                // If workflow fetch fails, user doesn't have access
                if (workflowError.response?.status === 403 || workflowError.response?.status === 404) {
                    return { hasAccess: false, error: 'Workflow not found or access denied' };
                }
                // Other errors might be network issues - allow fetchWorkflow to handle them
                return { hasAccess: true, userId: meResponse.data.id };
            }
        } catch (error) {
            // Token invalid or other auth error
            if (error.response?.status === 401 || error.response?.status === 403) {
                return { hasAccess: false, error: 'Unauthorized' };
            }
            return { hasAccess: false, error: error.message || 'Authentication failed' };
        }
    };

    const body_desktop_reminder = (
       
            <div style={modalStyle} className={breakpoint !== 'large' ? classes.modalSmall : classes.modal}>
                <img style={{ marginBottom: breakpoint !== 'large' ? '20px' : '50px' }} height='25px' src="https://cdn.workload.co/wp-content/uploads/cropped-new-logo-only-900x193-1.png" />
                
                <br />
                <Typography style={{width: '100%', fontSize: breakpoint !== 'large' ? '30px' : null}} variant="h4" id="simple-modal-title">Switch to <mark style={{ background: 'linear-gradient(to top, gold 50%, transparent 50%' }}>Desktop</mark></Typography>
                <br/>
                <Typography style={{ fontSize: breakpoint !== 'large' ? '14px' :'18px' }} id="simple-modal-subtitle">It looks like you're on mobile. Our software really does its magic on desktop. Hit <strong>Remind Me</strong> to get an email with your unique sign in link!</Typography>
                <br />
                
                <TextField error={validworkemail === true ? 0 : 1} helperText={validworkemail === true ? "Enter a valid email address" : "INVALID EMAIL"} style={{ width: '100%' }} id="workemail" variant="outlined" label="Work Email" onChange={(e) => setDeskWorkemail(e.target.value)} /><br /><br />
                
                <Button variant="text" color="default" style={{ float: 'left', textTransform: 'none', fontSize: breakpoint === 'small' ? '14px' : null }} onClick={() => setDesktopReminderModal(false)}>Dismiss</Button>
                <Button disabled={deskworkemail ? 0 : 1} style={{ width: breakpoint === 'small' ? '140px' : '175px', textTransform: 'none', float: 'right', display: 'block'}} variant='contained' color='primary' onClick={() => handleDeskWorkemailChange(deskworkemail)}>{ desktopreminderloading === true ? <CircularProgress size={30} color="secondary" /> : 
                <div>
               
                <Typography style={{float: 'left', fontWeight: 'bold', color: 'white', marginTop: '2px',fontSize: breakpoint === 'small' ? '14px' : null }}>Remind Me</Typography> 
                <ScheduleRoundedIcon style={{ marginLeft: '5px', color: 'white', float: 'right', display: 'block' }} /></div> }  
                </Button> 
                
                <br />
            </div>
    );

    const sendLoggedOutToAuthorizer = (isLoggedOut) => {
        // Redirect to signup page if user is logged out
        const currentUrl = window.location.href;
        window.location.href = `https://automate.workload.co/auth/signup?next=${encodeURIComponent(currentUrl)}`;
    };

    const [counter, setCounter] = useState(7);
    useEffect(() => {
        const timer =
          counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
          if (counter === 0 && !user && modalwidth < 430){
           // setDesktopReminderModal(true);
          }
        return () => clearInterval(timer);
      }, [counter]);


      
      
      const colors = [
        'primary',
        'secondary',
      ];
      
      const [color, setColor] = useState(0);
    
      useEffect(() => {
        if (workflowloading === true) {
          const interval = setInterval(() => {
            setColor((v) => (v === 2 ? 0 : v + 1));
          }, 1500);
          
          return () => clearInterval(interval);
        }
      }, [workflowloading]); 

     //dagre graph layouting to make evenly spaced nodes and auto layout to share lines evenly
   // Define the size and spacing of nodes
const nodeWidth = 450;
const nodeHeight = 80;
const nodeSpacingX = 20;
const nodeSpacingY = 100;

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));
dagreGraph.setGraph({ rankdir: 'TB', nodesep: nodeSpacingX, ranksep: nodeSpacingY });

const getLayoutedElements = (elements) => {
  const nodes = elements.filter(el => !el.source); // Elements without a source are nodes
  const edges = elements.filter(el => el.source && el.target); // Elements with source and target are edges

  // Add nodes to the Dagre graph
  nodes.forEach(node => {
    dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
  });

  // Add edges to Dagre graph
  edges.forEach(edge => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  // Perform layout
  dagre.layout(dagreGraph);

  // Update the nodes' position based on Dagre layout
  // Update the nodes' position based on Dagre layout
const layoutedNodes = nodes.map(node => {
  const dagreNode = dagreGraph.node(node.id);
  
  // Return a new node object with updated position
  return {
    ...node, // spread existing node properties
    position: {
      x: dagreNode.x - nodeWidth / 2,
      y: dagreNode.y - nodeHeight / 2,
    },
  };
});

  return [...layoutedNodes, ...edges];
};
   
const [nodes, setNodes] = useState(elements.filter(el => !el.source));
const [edges, setEdges] = useState(elements.filter(el => el.source && el.target));

const layoutNodes = useCallback(() => {
  const layoutedElements = getLayoutedElements(elements);
  const layoutedNodes = layoutedElements.filter(el => !el.source);
  const layoutedEdges = layoutedElements.filter(el => el.source && el.target);
  setNodes([...layoutedNodes]);
  setEdges([...layoutedEdges]);
 // 
 /* if (reactFlowInstance) {
  reactFlowInstance.fitView({ padding: 0.1 }); // Layout nodes on initial load
 } */

  
}, [elements]);

// set the scroll boundaries to prevent infinite scrolling/panning...
// Compute a fixed translateExtent using useMemo. When showing skeleton steps, use a fixed extent.
const fixedTranslateExtent = useMemo(() => {
  if (nodes && nodes.length > 0) {
    const padding = 200; // adjust as needed
    const xs = nodes.map((n) => n.position.x + 225);
    const ys = nodes.map((n) => n.position.y);
    const minX = Math.min(...xs) - padding;
    const minY = Math.min(...ys) - padding;
    const maxX = Math.max(...xs) + padding;
    const maxY = Math.max(...ys) + padding;
   
    return [[minX, minY], [maxX, maxY]];
  }
  return [[0, 0], [1000, 1000]]; // default if no nodes
}, [nodes]); // Only re-compute if nodes array changes

const onLoad = (reactFlowInstance) => {
  setReactFlowInstance(reactFlowInstance)
};

 useEffect(() => {
   if (reactFlowInstance) {
     reactFlowInstance.fitView({ padding: 0.1 });
   }
 }, [reactFlowInstance]);

 // When any panel is visible, fit view after layout so nodes are always centered
 useEffect(() => {
   if (reactFlowInstance) {
     const t = setTimeout(() => reactFlowInstance.fitView({ padding: 0.1 }), 150);
     return () => clearTimeout(t);
   }
 }, [reactFlowInstance, selectedElement?.id]);

 // When workflow loads from empty state, fit view so nodes are centered (same as after clicking canvas)
 useEffect(() => {
   if (nodes.length === 0) {
     initialFitViewDone.current = false;
     return;
   }
   if (reactFlowInstance && nodes.length >= 2 && !initialFitViewDone.current) {
     const t = setTimeout(() => {
       reactFlowInstance.fitView({ padding: 0.1 });
       initialFitViewDone.current = true;
     }, 250);
     return () => clearTimeout(t);
   }
 }, [reactFlowInstance, nodes]);

// Trigger layout on load or with a button (you can integrate this anywhere)
useEffect(() => {
 
  layoutNodes(); // Layout nodes on initial load
 
  
}, [elements]);
 
    try {
        return (
            <>
            
                {workflow && elements && accessDenied === false ?
                    
                    <AppBarHeader selectedElement={selectedElement} breakpoint={breakpoint} isactive={active} sendLoggedOutToAuthorizer={sendLoggedOutToAuthorizer} activationRequestRef={activationRequestRef} style={{ width: '100vw' }} /> :
                   <> <AppBarHeaderDummy style={{ width: '100vw' }} />
                   <div style={{width: '100%', display: 'flex'}}>
                   <div style={{justifyContent: 'center', margin: '0 auto', width: '75%', textAlign: 'center'}}>
                   <div style={{ marginTop: '50px'}}>
                   <Typography variant="h3">No access to workflow</Typography>
                   </div>
                   <div style={{marginTop: '24px'}}><Typography style={{fontSize: '20px'}} variant="body">You either don't have permission to see this Workflow or the Workflow does not exist.
                    Please try reloading the page or switching to a different account.</Typography></div>
                    <div style={{marginTop: '40px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px'}}>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            size="large"
                            style={{ 
                                textTransform: 'none', 
                                fontSize: '16px',
                                padding: '10px 30px',
                                minWidth: '200px'
                            }}
                            onClick={() => {
                                const currentUrl = window.location.href;
                                window.location.href = `https://automate.workload.co/auth/signin?next=${encodeURIComponent(currentUrl)}`;
                            }}
                        >
                            Login
                        </Button>
                        <Typography style={{fontSize: '14px', color: '#666'}} variant="body2">
                            or{' '}
                            <a 
                                href={`https://automate.workload.co/auth/signup?next=${encodeURIComponent(window.location.href)}`}
                                style={{ color: '#0069ea', textDecoration: 'none', cursor: 'pointer' }}
                                onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                            >
                                create an account for free
                            </a>
                        </Typography>
                    </div>
                    <div style={{marginTop: '24px', justifyContent: 'center'}}>
                        <Typography style={{fontSize: '16px'}} variant="body">
                            Need help?{' '}
                            <a 
                                href="https://www.workload.co/contact"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#0069ea', textDecoration: 'none', cursor: 'pointer' }}
                                onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                            >
                                Contact support
                            </a>
                            .
                        </Typography>
                    </div>
                   </div>
                   </div>  </>}
                {workflowloading === false && workflow && accessDenied === false ?
                    <div onKeyDown={handleKeyDownSave} tabIndex='0' style={{ width: '100vw', height: '100vh' }}>      
                        <div style={{ display: 'flex', width: '100%', height: '100vh' }}>
                        <ReactFlowProvider>
                            <>
                                <div style={{ flex: 1, minWidth: 0, height: '100%', position: 'relative' }}>
                                <ReactFlow
                                    elements={[...nodes, ...edges]}
                                    translateExtent={fixedTranslateExtent}
                                    connectionLineType="smoothstep"
                                    connectionLineStyle={{ stroke: '#0069ea', strokeWidth: 2 }}
                                    style={{ ...flowStyle, width: '100%', height: '100%' }}
                                    connectionLineComponent={ConnectionLine}
                                    onLoad={onLoad}
                                    onElementsRemove={onElementsRemove}
                                    onConnect={onConnect}
                                    onConnectStart={handleonConnectStart}
                                    onConnectStop={handleLineDrop}
                                    selectNodesOnDrag={false}
                                    onElementClick={handleElementClick}
                                    deleteKeyCode={248}
                                    onPaneClick={handlePaneClick}
                                    nodeTypes={nodeTypes}
                                    edgeTypes={edgeTypes}
                                    onNodeDragStop={handleNodeMove}
                                    snapToGrid={true}
                                    snapGrid={[20, 20]}
                                    nodesDraggable={false}
                                    paneMoveable={selectedElement ? false: true}
                                    zoomOnScroll={false}
                                    zoomOnPinch={false}
                                    zoomOnDoubleClick={false}
                                    panOnScroll={true}
                                >
                                   {notify && notify.status ? <Snackbar open={openalert} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                                        <Alert onClose={handleCloseAlert} severity={notify.status.status} variant="filled">
                                           <Typography style={{fontSize: '16px'}}>{notify.status.message}</Typography>
                                        </Alert>
                                    </Snackbar> : null }
                                    
                                    <Modal
                                    style={{display:'flex',alignItems:'center',justifyContent:'center'}}
                                        open={desktopReminderModal}
                                        onClose={handleDesktopModalClose}
                                        aria-labelledby="simple-modal-title"
                                       
                                    >
                                        {body_desktop_reminder}
                                    </Modal>{ elements?.length > 8 ? 
                                    <MiniMap
                                    style={{marginBottom: '65px',position: 'absolute',left: 50}}
                                        nodeStrokeColor={(n) => {
                                        if (n.style?.background) return n.style.background;
                                        if (n.type === 'trigger') return '#ff0072';
                                        if (n.type === 'action') return '#0069ea';
                                        

                                        return '#eee';
                                        }}
                                        nodeColor={(n) => {
                                        if (selectedElement?.id === n.id) return '#000000'
                                        if (n.style?.background) return n.style.background;
                                        if (n.type === 'trigger') return '#ff0072';
                                        if (n.type === 'action') return '#0069ea';
                                        
                                        return '#fff';
                                        }}
                                        nodeBorderRadius={2}
                                    /> : null }
                                     <Controls style={{marginBottom: '65px'}} />
                                    <Background
                                        variant="dots"
                                        gap={16}
                                        size={1}
                                        color={theme.palette.type === 'dark' ? '#3E5060' : '#d7d5d2'}
                                        />
                                </ReactFlow>
                                </div>
                            </>
                        </ReactFlowProvider>
                                {selectedElement != null ? (
                                <div
                                    style={{
                                        flex: '0 0 550px',
                                        minWidth: 500,
                                        maxWidth: '40vw',
                                        height: '100vh',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        borderLeft: '2px solid #0069ea',
                                        boxSizing: 'border-box',
                                        background: theme.palette.background.paper,
                                    }}
                                >
                                    <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                    {selectedElement?.type === 'action' ? (
                                        <ReadOnlyActionPanel key={selectedElement?.id} store={reduxStore} inlineLayout breakpoint={breakpoint} user={user} tenant={tenant} selectedNode={selectedElement} onPaneClick={handlePaneClick} sendNode={updateNode} deleteNode={onElementsRemove} workflowID={workflow.id} sendLoggedOutToAuthorizer={sendLoggedOutToAuthorizer}/>
                                    ) : selectedElement?.type === 'trigger' ? (
                                        <ReadOnlyTriggerPanel key={selectedElement?.id} store={reduxStore} inlineLayout className='trigger-card' breakpoint={breakpoint} user={user} tenant={tenant} selectedNode={selectedElement} onPaneClick={handlePaneClick} sendNode={updateNode} sendLoggedOutToAuthorizer={sendLoggedOutToAuthorizer} onActivateForListening={() => { activationRequestRef.current?.requestActivateForListening?.(); }} />
                                    ) : selectedElement?.type === 'filter' ? (
                                        <FilterPanel key={selectedElement?.id} inlineLayout selectedEdge={selectedElement} onPaneClick={handlePaneClick} />
                                    ) : null}
                                    </div>
                                </div>
                                ) : null}
                        </div>
                    </div> :
                    workflowloading === true ? <div style={{margin: 'auto', width: '100%', display: 'flex', justifyContent: 'center', top: '50%'}} ><CircularProgress style={{ left: '50%', top: '50%', position: 'absolute' }} color="secondary" size={50} /></div> : null }
            
            {/* Tenant Selection Modal */}
            <Dialog
                open={tenantModalOpen}
                onClose={handleTenantModalClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    style: {
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: '8px'
                    }
                }}
            >
                <DialogTitle style={{ paddingBottom: '12px', textAlign: 'center' }}>
                    <Typography style={{ fontSize: '20px', fontWeight: 600, color: theme.palette.text.primary, marginBottom: '8px' }}>
                        Select Workspace
                    </Typography>
                    <Typography style={{ fontSize: '16px', fontWeight: 500, color: theme.palette.text.secondary }}>
                        Choose which workspace to add this workflow to
                    </Typography>
                </DialogTitle>
                <DialogContent style={{ padding: '16px 24px' }}>
                    <DialogContentText style={{ marginBottom: '16px', color: theme.palette.text.secondary }}>
                        You have multiple workspaces. Please select which workspace you'd like to add this workflow template to.
                    </DialogContentText>
                    <FormControl fullWidth variant="outlined" style={{ marginTop: '16px' }}>
                        <InputLabel style={{ color: theme.palette.text.secondary }}>Workspace</InputLabel>
                        <Select
                            value={selectedTenant}
                            onChange={(e) => setSelectedTenant(e.target.value)}
                            label="Workspace"
                            style={{ 
                                color: theme.palette.text.primary,
                                backgroundColor: theme.palette.background.paper
                            }}
                        >
                            {tenantSelection && tenantSelection.tenants && tenantSelection.tenants.map((tenant) => (
                                <MenuItem key={tenant.id} value={tenant.id} style={{ color: theme.palette.text.primary }}>
                                    {tenant.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', padding: '8px 16px 16px', gap: '12px' }}>
                    <Button 
                        onClick={handleTenantModalClose} 
                        variant="outlined" 
                        style={{ 
                            textTransform: 'none', 
                            minWidth: '100px',
                            color: theme.palette.text.secondary,
                            borderColor: theme.palette.divider
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleTenantSelect} 
                        variant="contained" 
                        color="primary" 
                        disabled={!selectedTenant}
                        style={{ 
                            textTransform: 'none', 
                            minWidth: '100px',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        Add to Workspace
                    </Button>
                </DialogActions>
            </Dialog>
            </>
        )
    }
    catch (e) {

        var airtableConfig = {
            method: 'post',
            url: 'https://api.airtable.com/v0/appb76LyMibAJXsfE/FrontendErrors',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${config.AIRTABLE_API_KEY}`
            },
            data: {
                'records': [
                    {
                        'fields': {
                            'Error source': 'flowApp',
                            'Error': e.toString()
                        }
                    }
                ]
            }
        }

        axios(airtableConfig)

        return (
            <div>
                Something broke, please refresh
            </div>
        )
    }
};
